import axios from "axios";
import config from "./server.js";
import url from "./url.js";
import { toast } from "react-toastify";

function Request(
  method,
  url_key,
  headers = {},
  data = {},
  args = [],
  onSuccess = () => {},
  onFailed = () => {},
  extra = undefined,
  init = []
) {
  if (typeof headers !== "object") {
    throw new Error("Invalid headers, headers must be an object");
  }

  if (typeof data !== "object") {
    throw new Error("Invalid data, data must be an object");
  }

  if (!Array.isArray(args)) {
    throw new Error("Invalid arguments, data must be an array");
  }

  if (typeof onSuccess !== "function") {
    throw new Error("Invalid onSuccess, onSuccess must be a function");
  }

  if (typeof onFailed !== "function") {
    throw new Error("Invalid onSuccess, onSuccess must be a function");
  }

  if (method === "get" && data) {
    data = {
      params: data
    };
  }

  for (let header in headers) {
    axios.defaults.headers.common[header] = headers[header];
  }

  let api = url[url_key];
  if (!api) {
    throw new Error("Invalid url key");
  }

  args.map((value, index) => (api = api.replace("{}", value)));

  if (typeof axios[method] !== "function") {
    throw new Error("Invalid method");
  }

  return axios[method](config.ATM_CLOUD.API + api, data)
    .then(function(response) {
      onSuccess(response, extra);
      return response.data;
    })
    .catch(function(error) {
      if (typeof error !== "undefined") {
        if (typeof error.response !== "undefined") {
          if (typeof error.response.data !== "undefined") {
            if (typeof error.response.data === "object") {
              onFailed(error, extra);
            } else {
              toast.error("An error occurred on the server side.");
              // Please don't send error to parameter onFailed. because server don't send valid error type.
              // and it will make error on frontend.
              onFailed();
            }
          }
        }
      }
      return init;
    });
}
export default Request;



// WEBPACK FOOTER //
// ./src/App/config/Request.js